import { CardType } from "src/components/shared-components/enum/enumCard";
import { GenericTag } from "./generic-tag";

/**
 * This class handle generic BIG tg
 */
export class BIGTag extends GenericTag {
  constructor() {
    super();
  }
  /**
   * Unpack a block and set expiration date,plantCode and cardNumber
   *
   * @param block   block that we have read
   * @param uid     tag UID
   */
  public unpack(block: string, uid: string): void {
    this._uid = uid;
    this._expirationDate = this.unpackExpirationDate(block);
    this._plantCode = this.unpackPlantCode(block);
    this._cardNumber = this.unpackCardNumber(block);
  }

  /**
   * Unpack block to read UID
   */
  public unpackBlockUID(block: string): void {
    this._uid = block;
  }

  /**
   * Build the block by expirationdate,plantcode and cardnumber
   *
   * @param expirationDate  expiration date of tag
   * @param plantCode       plant code
   * @param cardNumber      card number
   * @returns {string}      block to write
   */
  public pack(
    expirationDate: string,
    plantCode: number,
    cardNumber: string,
    cardType: CardType
  ): string {
    let type: string = cardType.toString();
    const blockZ: string = "000000";
    let checksum: string = "";
    let block: string = "";

    type = ("0" + parseInt(type, 10).toString(16)).slice(-2);
    const blockPlantCode: string = ("00000000" + plantCode.toString(16)).slice(
      -8
    );
    const blockCardNumber: string = ("000000" + cardNumber.toString()).slice(
      -6
    );
    const arExDate: string[] = expirationDate.split("/");
    const gg: string = ("00" + parseInt(arExDate[0], 10).toString(16)).slice(
      -2
    );
    const mm: string = ("00" + parseInt(arExDate[1], 10).toString(16)).slice(
      -2
    );
    const yy: string = ("00" + parseInt(arExDate[2], 10).toString(16)).slice(
      -2
    );
    const blockExpDate: string = gg + mm + yy;
    const firstPart: string =
      blockPlantCode + blockCardNumber + type + blockExpDate + blockZ;
    checksum = ("00" + this.calculateChecksum(firstPart)).slice(-2);

    block = firstPart + checksum + "00";

    return block;
  }

  /**
   * Get expiration date in the block
   *
   * @param block      block that we have read
   * @returns {string} expiration date in format gg/mm/yy
   */
  private unpackExpirationDate(block: string): string {
    const gg: string = ("00" + parseInt(block.substring(16, 18), 16)).slice(-2);
    const mm: string = ("00" + parseInt(block.substring(18, 20), 16)).slice(-2);
    const yy: string = parseInt(block.substring(20, 22), 16).toString();

    return gg + "/" + mm + "/" + yy;
  }

  /**
   * Get plant code in the block
   *
   * @param block       block that we have read
   * @returns {number}  plant code
   */
  private unpackPlantCode(block: string): number {
    return parseInt(block.substring(0, 8), 16);
  }

  /**
   * Get card number in the block
   *
   * @param block      block that we have read
   * @returns {number} card number
   */
  private unpackCardNumber(block: string): number {
    return parseInt(block.substring(8, 14), 10);
  }
}
